import * as React from "react";
import {
    List, Datagrid, Edit, Create, SimpleForm, TextField, EditButton, TextInput,
    ReferenceArrayInput, SelectArrayInput, useTranslate, useLocaleState
} from 'react-admin';

// Components
import EmptyList from "../components/misc/EmptyList";

// Entity
const entity = "featureds";

export const FeaturedList = (props) => {
    const translate = useTranslate();
    return (
        <List {...props} title={translate('featureds.title', { _: 'Öne Çıkan Liste Ayarları' })} empty={<EmptyList entity={entity} />} exporter={false}>
            <Datagrid>
                <TextField source="id" label={"ID"} />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export const FeaturedEdit = (props) => {
    const translate = useTranslate();
    const [locale] = useLocaleState();
    const localeNameKey = locale === 'tr' ? 'name.tr' : 'name.en';

    return (
        <Edit title={translate('featureds.edit_featured', { _: 'Öne Çıkan Kaydı Düzenle' })} {...props}>
            <SimpleForm redirect={`/${entity}`}>
                <TextInput source="id" label={"ID"} disabled />
                <ReferenceArrayInput source="venues" reference="venues" label={translate('featureds.venues', { _: 'Mekanlar' })} sort={{ field: 'name', order: 'ASC' }} defaultValue={[]} perPage={150}>
                <SelectArrayInput optionText={localeNameKey} fullWidth
                        matchSuggestion={() => true}
                        filterToQuery={searchText => ({ name: searchText })}
                        defaultValue={[]}
                    />
                </ReferenceArrayInput>
            </SimpleForm>
        </Edit>
    );
};

export const FeaturedCreate = (props) => {
    const translate = useTranslate();
    const [locale] = useLocaleState();
    const localeNameKey = locale === 'tr' ? 'name.tr' : 'name.en';

    return (
        <Create title={translate('featureds.new_featured', { _: 'Yeni Öne Çıkan Kayıt' })} {...props}>
            <SimpleForm redirect={`/${entity}`}>
                <TextInput source="id" label={"ID"} />
                <ReferenceArrayInput source="venues" reference="venues" label={translate('featureds.venues', { _: 'Mekanlar' })} sort={{ field: 'name', order: 'ASC' }} defaultValue={[]} perPage={150}>
                    <SelectArrayInput optionText={localeNameKey} fullWidth
                        matchSuggestion={() => true}
                        filterToQuery={searchText => ({ name: searchText })}
                        defaultValue={[]}
                    />
                </ReferenceArrayInput>
            </SimpleForm>
        </Create>
    );
};
